import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import LuminateLogo from "assets/images/logo.png";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { fetchJSON } from "helpers/axios";
import { NotificationContainer, NotificationManager } from "react-notifications";




const CreateStaffAccount = () => {

  const history = useHistory();
  const [input, setInput] = useState({
    staffNumber: "",
    password: "",
    confirmPassword: "",
    Email: ""
  })
  const [loader, setLoader] = useState(false);
  const [confirmStaffNumber, setConfirmStaffNumber] = useState(false);

  const CheckStaff = async () => {
    setLoader(true);

    try {
      const response = await fetchJSON(`api/Staff/CheckStaffByStaffNumber?StaffNumber=${input?.staffNumber}`,
        null,
        "GET"
      );

      if (response.Status == "Ok") {
        setLoader(false);
        setConfirmStaffNumber(true);
        setInput({ ...input, Email: response?.Data?.Email });
      } else {
        setLoader(false);
        NotificationManager.error(response.Message);
      }
    } catch (error) {
      setLoader(false)
      NotificationManager.error(error);
    }
  }


  const handleSubmit = async () => {
    setLoader(true);

    try {
      if (!validateEmail(input.Email)) {
        NotificationManager.warning("Not a valid Email address");
        setLoader(false);
        return false;
      }
      if (input.password !== input.confirmPassword) {
        NotificationManager.warning("Password and Confirm Password do not match");
        setLoader(false);
        return false;
      }
      if (input.password.length < 6) {
        NotificationManager.warning("Password cannot be less than 6 characters");
        setLoader(false);
        return false;
      }

      let account = {
        SchoolId: 1,
        StaffNumber: input.staffNumber,
        Password: input.password,
        ConfirmPassword: input.confirmPassword,
        Email: input.Email,
      }
      const response = await fetchJSON("api/Account/CreateStaffAccountByStaffNumber",
        account,
        "POST"
      )

      if (response.Status === "OK") {
        setLoader(false);
        NotificationManager.success(response.Message);
        setTimeout(() => { history.push("/admin") }, 1000);
      } else {
        setLoader(false);
        NotificationManager.error(response.Message);
      }
    } catch (error) {
      setLoader(false);
      NotificationManager.error(error);
    }
  }

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  return (
    <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
      <div className="app-login-main-content">
        <div className="app-logo-content d-flex align-items-center justify-content-center">
          <Link className="logo-lg" to="../" title="Luminate">
            <img src={LuminateLogo} alt="FedPolyLogo" title="FedPolyLogo" />
          </Link>
        </div>

        <div className="app-login-content">
          <div className="app-login-header mb-4">
            <h1>Staff Create Account</h1>
          </div>

          <div className="app-login-form">
            <form
            >
              <fieldset>

                <TextField
                  label={"Staff Number"}
                  fullWidth
                  onChange={(event) =>
                    setInput({ ...input, staffNumber: event.target.value })
                  }
                  value={input.staffNumber}
                  margin="normal"
                  type="text"
                  className="my-3 my-md-1"
                  required
                  variant="outlined"
                  disabled={confirmStaffNumber}
                />
                {confirmStaffNumber &&
                  <>
                    <TextField
                      type="email"
                      label={"Email"}
                      fullWidth
                      onChange={(event) =>
                        setInput({ ...input, Email: event.target.value })
                      }
                      value={input.Email}
                      margin="normal"
                      className="my-3 my-md-1"
                      required
                      variant="outlined"
                    />
                    <TextField
                      type="password"
                      label={"Password"}
                      fullWidth
                      onChange={(event) =>
                        setInput({ ...input, password: event.target.value })
                      }
                      value={input.password}
                      margin="normal"
                      className="my-3 my-md-1"
                      required
                      variant="outlined"
                    />
                    <TextField
                      type="password"
                      label={"Confirm Password"}
                      fullWidth
                      onChange={(event) =>
                        setInput({ ...input, confirmPassword: event.target.value })
                      }
                      value={input.confirmPassword}
                      margin="normal"
                      className="my-3 my-md-1"
                      required
                      variant="outlined"
                    />
                  </>
                }
                <div className="my-3 d-flex align-items-center justify-content-between">
                  <Button
                    type="button"
                    variant="contained"
                    style={{ backgroundColor: "#540000", color: "#ffffff" }}
                    onClick={() => !confirmStaffNumber ? CheckStaff() : handleSubmit()}
                  >
                    {!confirmStaffNumber ? "Verify" : "Create"}
                  </Button>
                  <Link to="./AdminSignin">
                    Already have an account? Login
                  </Link>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
      {loader && (
        <div className="loader-view">
          <CircularProgress />
        </div>
      )}
      <NotificationContainer />
    </div>
  )
}

export default CreateStaffAccount